import { Box, keyframes } from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import { colors } from "../../config";

const ringPulse = keyframes`
  0% {
    transform: scale(0.55);
    opacity: 0.85;
  }
  70% {
    opacity: 0.25;
  }
  100% {
    transform: scale(2.4);
    opacity: 0;
  }
`;

const coreGlow = keyframes`
  0%, 100% {
    box-shadow:
      0 0 12px rgba(33, 150, 243, 0.55),
      0 0 24px rgba(30, 136, 229, 0.35);
  }
  50% {
    box-shadow:
      0 0 18px rgba(33, 150, 243, 0.75),
      0 0 32px rgba(21, 101, 192, 0.45);
  }
`;

const RING_DELAYS = ["0s", "0.55s", "1.1s"] as const;

type Props = {
  size?: number;
};

export default function VoiceAssistantMicAnimation({ size = 28 }: Props) {
  const ringSize = size * 2.1;

  return (
    <Box
      aria-hidden
      sx={{
        position: "relative",
        width: ringSize,
        height: ringSize,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
      }}
    >
      {RING_DELAYS.map((delay) => (
        <Box
          key={delay}
          sx={{
            position: "absolute",
            width: size,
            height: size,
            borderRadius: "50%",
            border: "2px solid rgba(33, 150, 243, 0.65)",
            animation: `${ringPulse} 1.8s ease-out infinite`,
            animationDelay: delay,
          }}
        />
      ))}
      <Box
        sx={{
          position: "relative",
          width: size,
          height: size,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: `linear-gradient(135deg, ${colors.primaryMain} 0%, ${colors.primaryDark} 55%, ${colors.primary200} 100%)`,
          color: "#fff",
          animation: `${coreGlow} 2s ease-in-out infinite`,
        }}
      >
        <MicIcon sx={{ fontSize: size * 0.48 }} />
      </Box>
    </Box>
  );
}
